import { SCREEN_LG, useMediaQuery } from '@volee/ui'
import { lazy, Suspense } from 'react'

// Dev only and lazy: `import.meta.env.DEV` is constant at build time, so production emits no
// chunk. From `lg` only: the floating button covers the bar's last slot on a phone.

const LazyQueryDevtools = lazy(async () => {
  const form = await import('@tanstack/react-query-devtools')
  return { default: form.ReactQueryDevtools }
})

const LazyRouterDevtools = lazy(async () => {
  const form = await import('@tanstack/react-router-devtools')
  return { default: form.TanStackRouterDevtools }
})

/** Query's devtools: they live next to the `QueryClientProvider`. */
export function QueryDevtools() {
  const desktop = useMediaQuery(SCREEN_LG)
  if (!import.meta.env.DEV || !desktop) return null

  return (
    <Suspense fallback={null}>
      <LazyQueryDevtools initialIsOpen={false} />
    </Suspense>
  )
}

/** Mounted INSIDE the route tree: outside the `RouterProvider` the state is null and the app blanks. */
export function RouterDevtools() {
  const desktop = useMediaQuery(SCREEN_LG)
  if (!import.meta.env.DEV || !desktop) return null

  return (
    <Suspense fallback={null}>
      <LazyRouterDevtools position="bottom-right" />
    </Suspense>
  )
}
